import { Component, OnInit, Renderer2 } from '@angular/core'

import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet, NavigationEnd } from '@angular/router'
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http'
import { getrolessuccess } from 'src/app/Store/menu-role/Role.action'
import { RoleModel } from "src/app/Store/Model/Role.model"
import { Store } from '@ngrx/store';
import { TokenService } from '../../../core/service/token.service';
import { SweetAlert } from 'src/app/shared/alert/sweet-alert';
import { McDataService } from 'src/app/core/service/mc-data.service';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { CallbackSigninService } from 'src/app/auth/containers/callback-signin/callback-signin.service';

export interface Menus{
  menu:string,
  data: [
      {
          menu: string,
          status: boolean,
          submenu: string,
          permission: {
              create: boolean,
              read: boolean,
              update: boolean,
              delete: boolean,
              export_excel: boolean
          },
          link: string,
          sublink: string,
          subName: string
      }
  ],
  submenu: string,
  permission: {
      create: boolean,
      read: boolean,
      update: boolean,
      delete: boolean,
      export_excel: boolean
  },
  link: string
}

@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  user: any
  menus:Array<Menus>=[]
  udid: any;
  isMonitorOrder : boolean = false
  isLoading: boolean = false

  alertService: SweetAlert = new SweetAlert();
  lastUrl: any = '';
  urls: any = [];
  jwtHelper: JwtHelperService = new JwtHelperService();
  uri:any
  isMonitorOrderChannelType : boolean = false

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private cookiesStorageService: CookieService,
    private http: HttpClient,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private store: Store,
    private mcDataService: McDataService,
    private callbackPageService: CallbackSigninService
    ) {
    this.user = this.tokenService.getDataToken()
    this.router.events.subscribe((event: any) => {
      const navEnd: NavigationEnd = event;
      if (navEnd.url && navEnd.url!='/skip' &&navEnd.url != this.uri) {
        let uri = navEnd.url;
        if (uri.indexOf('?') > -1) {
          const uriArray = uri.split('?');
          uri = uriArray[0];
        }
        this.uri=uri
        let ArrUri = uri.split('/');
        this.urls  = ArrUri;
        this.lastUrl = ArrUri[ArrUri.length - 1] ? ArrUri[ArrUri.length - 1] : ArrUri[ArrUri.length];
        if(ArrUri.length==3 && (ArrUri[1]=='monitor-order' || ArrUri[1]=='udid-management')){
          this.menus.forEach((el:any,idx: any)=>{
            var menu = el.menu.toLowerCase().split(' ').join('-')
            if(menu == ArrUri[1]){
              this.clearMenu()
              this.setNavMenu(idx)
              this.setNavSubMenu('/'+ArrUri[2],'#8ac5b9',"#fff")
            }
          })
        }
      }
    });
    window.addEventListener('popstate', (res:any) => {
      // console.log('User clicked back button', res);
      document.getElementById("nav-menu0")?.click()
    });
  }

  ngOnInit() {
    this.getMenuLinkByRole();
  }

  async getMenuLinkByRole() {
    this.isLoading=true
    const request = {
      role:  this.user.role
    }
    // this.menus = await this.http.post('/api/get-menu-link-by-role', request, {})
    // .toPromise().then((resp: any) =>
    //   (resp.data.filter(value => value.role.toString().toLowerCase().includes(this.user.role.toLowerCase()))));

    // this.menus = await this.http.post('/api/get-menu-by-role', request, {})
    // .toPromise().then((resp: any) =>
    //   (resp.data.categoriesList));

    // this.route.queryParams.subscribe((params) => { //จับ param ที่มาจาก URL
    // this.udid = params["udid"]
    //   if (!!this.udid) {
    //     localStorage.setItem("udid", this.udid.replaceAll('"', ""))
    //   }
    // });

    this.http.post('/api/getMenuByRole', request, {})
      .toPromise().then((resp: any) => {
        // resp=this.respMock
        // resp.data[0].menuList=this.mockData
        if (resp.data.length > 0) {
          var menusConv:Array<any> =resp.data[0].menuList
          menusConv.forEach((res:any, _idx) => {
            res.link='/'+res.menu.toLowerCase().split(' ').join('-')
            if (res.menu.toLowerCase() ==='macaddress' || res.menu.toLowerCase() ==='mac address') {
              res.link ='/mac-address'
            }
            if (res.menu.toLowerCase() === 'monitor order' ) {
              this.isMonitorOrderChannelType = true;
            }
            if (res.submenu.toLowerCase()!='all') {
              res.sublink='/'+res.submenu.toLowerCase().split(' ').join('-')
              switch (res.submenu){
                case "Monitor Order": {
                  res.subName = "Dashboard";
                  res.submenu = "dashboard"
                  res.sublink='/'
                  break;
                }
                // case "Monitor Report": {
                //   res.subName = "Report";
                //   break;
                // }
                default: {
                  res.subName = res.submenu
                  break;
                }
              }
            }
          })
          const grouped = menusConv.reduce((total:any, item:any) => {
            const existingGroup = total.find((group:any) => group.menu === item.menu);
            if (existingGroup) {
              existingGroup.data.push(item);
            } else {
              var linkadd
              if (item.submenu.toLowerCase() != 'all' ) {
                linkadd='/'+item.submenu.toLowerCase().split(' ').join('-')
              }
              total.push({
                menu: item.menu,
                data:  item.submenu.toLowerCase() != 'all'?[item]:[],
                submenu:item.submenu,
                permission: item.permission,
                // link: item.link
                link: linkadd?item.link+linkadd:item.link // for submenu != 'ALL'
              });
            }
            return total;
          }, []);

          // sort menu : Database position index 0
          let index = grouped.findIndex((obj: any)  => obj.menu.toLowerCase() === 'database')
          if (index !== -1 && index !== 0) {
            // let tmp = grouped.slice(0, index);
            // tmp.unshift(grouped[index])
	    // this.menus = tmp
            const temp = grouped[0]
            grouped[0] = grouped[index]
            grouped[index] = temp
            this.menus = grouped
          } else {
            this.menus = grouped
          }

          // this.menus = grouped
          sessionStorage.setItem('role', resp.data[0].role);
          this.store.dispatch(getrolessuccess({ rolelist: resp.data[0].menuList }))
        } else {
          this.router.navigate(['/'])
        }

        // monitor menu need have channel_order_type data
        if (this.isMonitorOrderChannelType) {
          this.http.post('/api/get-monitor-channel-order-type', {role: resp.data[0].role}, {})
          .toPromise().then((res: any) => {
            if (res.data.configChannel.length >= 1) {
              this.isMonitorOrder = true;
              sessionStorage.setItem('channel_order_type', JSON.stringify(res.data));
            } else if ( res.data.configChannel.length === 0) {
              this.isMonitorOrder = false;
              this.alertService.error('Unauthorized: Access is denied due to invalid Role.').then(() => {
                this.onSignOut()
              });
            }
          }).then(() => {
            this.isLoading = false
           //  this.router.navigate(["/udid-management"])
           // if (!!this.udid) {
           //  localStorage.setItem("udid", this.udid.replaceAll('"', ""))
           // } else {
            // this.isLoading = false
            if (this.menus.length > 0) {
              // this.router.navigateByUrl(this.menus[0].link)
              document.getElementById("nav-menu0")?.click()

              setTimeout(()=>{
                const parent:any = document.getElementsByTagName('a')
                .namedItem('nav-menu0')
                this.renderer.setStyle(parent, 'background-color', '#32ceb0');
                this.renderer.setStyle(parent,  "color", "#fff");
                if (this.menus[0].submenu && this.menus[0].submenu !== 'ALL') {
                  let submenuUrl = this.menus[0].submenu.toLowerCase().split(' ').join('-')
                  this.setNavSubMenu('/'+submenuUrl,'#8ac5b9',"#fff")
                }
              },100)
            } else {
              this.router.navigate(['/'])
            }
          // }
        });
      } else {
        this.isLoading = false
        // this.router.navigate(["/udid-management"])
        //  if (!!this.udid) {
        //   localStorage.setItem("udid", this.udid.replaceAll('"', ""))
        //  } else {
          // this.isLoading = false
          if (this.menus.length > 0) {
             this.router.navigateByUrl(this.menus[0].link)
            setTimeout(()=>{
              const parent:any = document.getElementsByTagName('a').namedItem('nav-menu0')
              this.renderer.setStyle(parent, 'background-color', '#32ceb0');
              this.renderer.setStyle(parent,  "color", "#fff");
              if (this.menus[0].submenu && this.menus[0].submenu !== 'ALL') {
                let submenuUrl = this.menus[0].submenu.toLowerCase().split(' ').join('-')
                this.setNavSubMenu('/'+submenuUrl,'#8ac5b9',"#fff")
              }
            },100)
          } else {
            this.router.navigate(['/'])
          }
        // }
      }
    }).then(() => {
      this.isLoading = false
    },((_err:any)=>{
      this.isLoading = false
    }));
  }

  goToHome() {
    this.router.navigate(['/'])
    this.clearMenu()
    // setTimeout(()=>{
    //   const parent:any = document.getElementsByTagName('a').namedItem('nav-menu0')
    //   this.renderer.setStyle(parent, 'background-color', 'transparent');
    //   this.renderer.setStyle(parent,  "color", "#614e47");
    // },100)
  }

  clearMenu(){
    this.menus.forEach((_el:any,index) => {
      if(_el.data.length>0 && _el.submenu !='ALL'){
        _el.data.forEach((_elem:any,idxSub: any) => {
          const all:any = document.getElementsByTagName('a').namedItem('nav-submenu'+_elem.sublink)
          if (all !== null) {
            this.renderer.setStyle(all, 'background-color', 'transparent');
            this.renderer.setStyle(all,  "color", "#614e47");
          }
        });
      }

        const all:any = document.getElementsByTagName('a').namedItem('nav-menu'+index)
        if (all !== null) {
          this.renderer.setStyle(all, 'background-color', 'transparent');
          this.renderer.setStyle(all,  "color", "#614e47");
        }
    });
  }
  setNavMenu(idx:any){
    const parent:any = document.getElementsByTagName('a').namedItem('nav-menu'+idx)
    if (parent !== null) {
      this.renderer.setStyle(parent, 'background-color', '#32ceb0');
      this.renderer.setStyle(parent,  "color", "#fff");
    }
  }
  setNavSubMenu(name:any,bg:any,color:any){
    const all:any = document.getElementsByTagName('a').namedItem('nav-submenu'+name)
    if (all !== null) {
      this.renderer.setStyle(all, 'background-color', bg);
      this.renderer.setStyle(all,  "color", color);
    }
  }

  onChangeMenu(url?:string, idx?:any, subMenu?:any) {
    this.isLoading=this.uri!=url?true:false
    this.clearMenu()
    // setTimeout(()=>{
      this.isLoading=false
      this.setNavMenu(idx)
      if(this.uri!==url){
        this.router.navigateByUrl('/skip', {skipLocationChange: true}).then(() => {
          // sessionStorage.setItem("url",url??'')
          this.router.navigate([url],{ state: { data: url } });
        })
      } else {
        if (subMenu !== 'ALL' && subMenu !== null) {
          let submenuUrl = subMenu.toLowerCase().split(' ').join('-')
          this.setNavSubMenu('/'+submenuUrl,'#8ac5b9',"#fff")
        }
      }
    // },500)
  }

  onChangeSubMenu(url:string, idx?:any, _datax?:any, _idxMenu?:any, nameId?:any) {
    this.isLoading=this.uri!=url?true:false
    this.clearMenu()

    // setTimeout(()=>{
        this.setNavMenu(_idxMenu)
      // _datax.forEach((_el:any,index: any) => {
        // this.setNavSubMenu(_el.sublink,'transparent',"#614e47")
      // });
      this.isLoading=false
      // setTimeout(()=>{
        this.setNavSubMenu(nameId,'#8ac5b9',"#fff")
        if(this.uri!=url){
          this.router.navigateByUrl('/skip', {skipLocationChange: true}).then(() => {
            this.router.navigate([url],{ state: { data: url } });
          })
        }
      // },50)
    // },50)
  }

  async onSignOut() {
    const accessToken = this.cookiesStorageService.get('accessToken')
    if (accessToken && !this.jwtHelper.isTokenExpired(accessToken)){
      await this.callbackPageService.logOutToken()
    }

    const ids_Token = this.mcDataService.getIdsToken()
    this.cookiesStorageService.deleteAll();
    if(!!ids_Token && ids_Token !== "" && ids_Token !== undefined && !this.jwtHelper.isTokenExpired(ids_Token)){
      window.location.href = environment.idsLogin.logOut + 'id_token_hint=' + ids_Token + '&post_logout_redirect_uri=' + environment.idsLogin.redirect_url
    } else {
      window.location.href = "/callback-signin"
    }
    localStorage.clear();
  }
}
